import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.labOrderListing || initialState;

export const selectOrders = createSelector(
  [selectDomain],
  (state) => state.orders
);

export const selectOrderCounts = createSelector(
  [selectDomain],
  (state) => state.orderCount
);

export const selectTotalOrders = createSelector(
  [selectDomain],
  (state) => state.totalOrders
);

export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectUpdatingStatus = createSelector(
  [selectDomain],
  (state) => state.statusUnderUpdate
);

export const selectDownloadStatus = createSelector(
  [selectDomain],
  (state) => state.downloadInProgress
);

export const selectIsLoadingListingData = createSelector(
  [selectDomain],
  (state) => state.isLoadingListingData
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectOrderCount = createSelector(
  [selectDomain],
  (state) => state.orderCount
);
export const selectLoaderForModal = createSelector(
  [selectDomain],
  (state) => state.loaderForModal
);

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectActiveNavOption = createSelector(
  [selectDomain],
  (state) => state.activeNavOption
);